import { GpsType } from '../../../../../../../global/components/layout/layout-models';
import { DocuSignRequest } from '../../../../docusign/models/docusign-models';
import { LayDcPlanAdoptionContentModel, LayDcPlanFormModel } from '../../models/plan-adoption-form-models';
import { GetAmendLayDcFormContentModel, GetLayDCPreviousValues } from '../plan-amend-helper';
import { LayDcIndemnifyWizard } from './lay-dc-indemnify-wizard';

export class LayDcAmendIndemnifyWizard extends LayDcIndemnifyWizard {

    getFormContentModel(): LayDcPlanAdoptionContentModel {

        const institutionSettings = this.epiContent?.institutionSettingsState?.epiContent;
        const content = super.getFormContentModel();
        const amendCommonFormContentModel = GetAmendLayDcFormContentModel(content, institutionSettings);

        return {
            ...amendCommonFormContentModel,
            gpsType: GpsType.LayDcAmendIndemnify,              
            indemnifyDocuSignFinishText: institutionSettings?.amendLayDCIndemnifyDocuSignFinishText,
            indemnifyDocuSignRejectText: institutionSettings?.amendLayDCIndemnifyDocuSignRejectText,
            indemnifyWarningTitle: institutionSettings?.amendLayDCIndemnifyWarningTitle,
            indemnifyWarningInstruction1: institutionSettings?.amendLayDCIndemnifyWarningInstruction1,
            indemnifyWarningInstruction2: institutionSettings?.amendLayDCIndemnifyWarningInstruction2,
            indemnifyDocuSignTemplateId: institutionSettings?.amendLayDCIndemnifyDocuSignTemplateId,
            indemnifyDocuSignSubject: institutionSettings?.amendLayDCIndemnifyDocuSignSubject,
            indemnifySuccessMessage: institutionSettings?.amendLayDCIndemnifySuccessMessage,            
        };
    }

    prepareIndemnificationDocuSignRequest(): DocuSignRequest {

        const defaultRequest = super.prepareIndemnificationDocuSignRequest();
        
        const docuSignRequest: DocuSignRequest = {
            ...defaultRequest,            
        };

        return docuSignRequest;
    }

    getPreviousValues(): LayDcPlanFormModel {

        const previousValues = this.wizardOptions?.location?.state?.request?.values;

        if (previousValues) {
            return previousValues;
        }

        const defaultValues = this.getDefaultFormValues();
        return GetLayDCPreviousValues(this.wizardOptions?.dcPlanDetail, defaultValues);
    }
}